type Option = {
    label: string;
    value: string;
};

export const mode = [
    {
        value: 'view',
        label: 'profile.mode.viewMode',
    },
    {
        value: 'edit',
        label: 'profile.mode.editMode',
    },
];

export const responsibilities: Option[] = [
    {
        label: 'responsibilities.business_capability_modelling',
        value: 'business_capability_modelling',
    },
    {
        label: 'responsibilities.bi_architecture',
        value: 'bi_architecture',
    },
    {
        label: 'responsibilities.application_portfolio_management',
        value: 'application_portfolio_management',
    },
    {
        label: 'responsibilities.infra_netwerk_design',
        value: 'infra_network_design',
    },
    {
        label: 'responsibilities.business_architecture',
        value: 'business_architecture',
    },
    {
        label: 'responsibilities.engineering',
        value: 'engineering',
    },
    {
        label: 'responsibilities.organizational_design',
        value: 'organizational_design',
    },
    {
        label: 'responsibilities.data_modelling',
        value: 'data_modelling',
    },
    {
        label: 'responsibilities.application_architecture',
        value: 'application_architecture',
    },
    {
        label: 'responsibilities.application_integration',
        value: 'application_integration',
    },
    {
        label: 'responsibilities.implement_it_industry_standards',
        value: 'implement_it_industry_standards',
    },
    {
        label: 'responsibilities.security',
        value: 'security',
    },
    {
        label: 'responsibilities.services_design',
        value: 'services_design',
    },
    {
        label: 'responsibilities.determine_architecture_principles',
        value: 'determine_architecture_principles',
    },
    {
        label: 'responsibilities.roadmapping_strategy',
        value: 'roadmapping_strategy',
    },
    {
        label: 'responsibilities.roadmapping_projects',
        value: 'roadmapping_projects',
    },
    {
        label: 'responsibilities.project_architecture_designs',
        value: 'project_architecture_designs',
    },
    {
        label: 'responsibilities.architecture_visualization',
        value: 'architecture_visualization',
    },
    {
        label: 'responsibilities.building_block_design',
        value: 'building_block_design',
    },
    {
        label: 'responsibilities.solutions_modelling',
        value: 'solutions_modelling',
    },
    {
        label: 'responsibilities.business_analysis',
        value: 'business_analysis',
    },
    {
        label: 'responsibilities.project_portfolio_management',
        value: 'project_portfolio_management',
    },
    {
        label: 'responsibilities.stakeholder_management',
        value: 'stakeholder_management',
    },
    {
        label: 'responsibilities.risk_management',
        value: 'risk_management',
    },
    {
        label: 'responsibilities.internal_communications',
        value: 'internal_communications',
    },
    {
        label: 'responsibilities.create_requirements',
        value: 'create_requirements',
    },
    {
        label: 'responsibilities.progress_reporting',
        value: 'progress_reporting',
    },
    {
        label: 'responsibilities.other',
        value: 'other',
    },
];

export const departments: Option[] = [
    { label: 'departments.it_general', value: 'it_general' },
    { label: 'departments.it_architecture', value: 'it_architecture' },
    { label: 'departments.it_infra', value: 'it_infra' },
    { label: 'departments.it_operations', value: 'it_operations' },
    { label: 'departments.it_development', value: 'it_development' },
    {
        label: 'departments.human_resoure_management',
        value: 'human_resoure_management',
    },
    { label: 'departments.risk_control', value: 'risk_control' },
    { label: 'departments.manufacturing', value: 'manufacturing' },
    { label: 'departments.finance', value: 'finance' },
    { label: 'departments.marketing', value: 'marketing' },
    { label: 'departments.communications', value: 'communications' },
    { label: 'departments.service_department', value: 'service_department' },
    { label: 'departments.customer_support', value: 'customer_support' },
    { label: 'departments.procurement', value: 'procurement' },
    { label: 'departments.sales', value: 'sales' },
    { label: 'departments.operations', value: 'operations' },
    { label: 'departments.production', value: 'production' },
    { label: 'departments.engineering', value: 'engineering' },
    {
        label: 'departments.research_development',
        value: 'research_development',
    },
    { label: 'departments.data_analysis', value: 'data_analysis' },
    { label: 'departments.project_management', value: 'project_management' },
    {
        label: 'departments.information_management',
        value: 'information_management',
    },
    { label: 'departments.security', value: 'security' },
    { label: 'departments.general_management', value: 'general_management' },
    {
        label: 'departments.other_business_department',
        value: 'other_business_department',
    },
    { label: 'departments.other_it_department', value: 'other_it_department' },
    { label: 'departments.other', value: 'other' },
];

export const functionsList: Option[] = [
    { label: 'functions.enterprise_architect', value: 'enterprise_architect' },
    { label: 'functions.business_architect', value: 'business_architect' },
    { label: 'functions.process_architect', value: 'process_architect' },
    { label: 'functions.security_architect', value: 'security_architect' },
    {
        label: 'functions.information_architect',
        value: 'information_architect',
    },
    {
        label: 'functions.application_architect',
        value: 'application_architect',
    },
    {
        label: 'functions.integration_architect',
        value: 'integration_architect',
    },
    { label: 'functions.infra_architect', value: 'infra_architect' },
    { label: 'functions.solution_architect', value: 'solution_architect' },
    { label: 'functions.process_engineer', value: 'process_engineer' },
    {
        label: 'functions.integration_specialist',
        value: 'integration_specialist',
    },
    {
        label: 'functions.infra_solution_designer',
        value: 'infra_solution_designer',
    },
    {
        label: 'functions.information_data_designer',
        value: 'information_data_designer',
    },
    { label: 'functions.business_consultant', value: 'business_consultant' },
    {
        label: 'functions.application_portfolio_manager',
        value: 'application_portfolio_manager',
    },
    {
        label: 'functions.project_portfolio_manager',
        value: 'project_portfolio_manager',
    },
    {
        label: 'functions.functional_application_manager',
        value: 'functional_application_manager',
    },
    {
        label: 'functions.technical_application_manager',
        value: 'technical_application_manager',
    },
    {
        label: 'functions.technical_maintenance',
        value: 'technical_maintenance',
    },
    { label: 'functions.service_manager', value: 'service_manager' },
    { label: 'functions.cio_cfo', value: 'cio_cfo' },
    {
        label: 'functions.it_operations_manager',
        value: 'it_operations_manager',
    },
    {
        label: 'functions.business_continuity_manager',
        value: 'business_continuity_manager',
    },
    { label: 'functions.project_manager', value: 'project_manager' },
    { label: 'functions.vendor_manager', value: 'vendor_manager' },
    { label: 'functions.compliance_manager', value: 'compliance_manager' },
    { label: 'functions.business_manager', value: 'business_manager' },
    { label: 'functions.servicedesk_employee', value: 'servicedesk_employee' },
    { label: 'functions.business_employee', value: 'business_employee' },
    { label: 'functions.other', value: 'other' },
    { label: 'functions.privacy_officer', value: 'privacy_officer' },
    { label: 'functions.security_officer', value: 'security_officer' },
    { label: 'functions.information_manager', value: 'information_manager' },
    { label: 'functions.analyst', value: 'analyst' },
    { label: 'functions.bluedolphin_admin', value: 'bluedolphin_admin' },
];
